import { BotIcon, UserRoundIcon } from "lucide-react";

import { AssigneeAvatar } from "./AssigneeAvatar";

export function TaskAssigneeIdentity(props: {
  readonly name: string | null;
  readonly avatarUrl: string | null | undefined;
  readonly kind: "human" | "agent" | null;
  readonly agentId?: string | null | undefined;
  readonly className?: string | undefined;
  readonly showUnassigned?: boolean;
}) {
  if (props.name === null) {
    return props.showUnassigned ? (
      <span
        aria-label="Unassigned"
        title="Unassigned"
        className="inline-flex size-5 items-center justify-center rounded-full bg-muted text-muted-foreground/70"
      >
        <UserRoundIcon className="size-3" aria-hidden />
      </span>
    ) : null;
  }
  if (props.kind === "agent") {
    const identity = props.agentId ?? "unknown Agent ID";
    return (
      <span
        aria-label={`Agent assignee: ${props.name}, ${identity}`}
        title={`${props.name} · ${identity}`}
        className={`inline-flex size-5 items-center justify-center rounded bg-primary/10 text-primary ${props.className ?? ""}`}
      >
        <BotIcon className="size-3" aria-hidden />
      </span>
    );
  }
  return (
    <span
      role="img"
      aria-label={props.name}
      title={props.name}
      className="inline-flex size-5 shrink-0 items-center justify-center overflow-hidden rounded-full"
    >
      <span aria-hidden className="contents">
        <AssigneeAvatar
          name={props.name}
          avatarUrl={props.avatarUrl ?? null}
          {...(props.className === undefined ? {} : { className: props.className })}
        />
      </span>
    </span>
  );
}
